<template>
  <a-modal
    :visible="visible"
    :title="'Import đơn hàng'"
    @cancel="closeModal"
    @ok="submitConfirm"
    :cancelText="'Đóng'"
    :okText="'Xác nhận'"
    :maskClosable="false"
    :destroyOnClose="false"
  >
    <a-spin :spinning="loading">
      <a-card style="border: none; padding: 0px 10px">
        <a-form-model :model="form" ref="ruleForm">
          <a-row :gutter="16">
            <a-col :xs="24" :md="24" :lg="24">
              <a-form-model-item label="File ký">
                <a-upload
                  name="file"
                  :multiple="true"
                  :accept="'.pdf, .xlsx, .jpg,.png'"
                  :show-upload-list="true"
                  :before-upload="beforeUpload"
                  :remove="removeFile"
                >
                  <a-button> <a-icon type="upload" /> Upload File</a-button>
                </a-upload>
              </a-form-model-item>
              <a href="/templates/file-mau-import-don-dat-hang.xlsx" download>Tải file mẫu</a>
            </a-col>
          </a-row>
        </a-form-model>
      </a-card>
    </a-spin>
  </a-modal>
</template>
<script>

import { importFileOrder } from '@/api/pre-order'
// import { axios } from '@/utils/request'

export default {
  props: {
    visibleImport: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data () {
    return {
      visible: false,
      form: {

      },
      fileList: [],
      loading: false
    }
  },
  mounted () {
    if (this.visibleImport === true) {
      this.visible = true
    } else {
      this.visible = false
    }
  },
  methods: {
    closeModal () {
      this.visible = false
      this.$emit('closePopup')
    },
    beforeUpload (data) {
      data.status = 'done'
      const object = {
        fileName: data.name,
        fileType: data.name.substr(data.name.lastIndexOf('.')),
        dataBase64: '',
        uid: data.uid
      }
      const file64 = this.getBase64(data)
      file64.then(data => {
        object.dataBase64 = data.slice(data.indexOf('base64,') + 7)
      })
      this.fileList.push(object)
      return false
    },
    getBase64 (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
    removeFile (file) {
      if (file) {
        this.fileList.forEach((item, index) => {
          if (item.uid === file.uid) {
            this.fileList.splice(index, 1)
          }
        })
      }
    },
    submitConfirm () {
      const params = {
        fileName: this.fileList[0].fileName,
        dataBase64: this.fileList[0].dataBase64
      }
      this.loading = true
      importFileOrder(params).then(rs => {
        if (rs) {
          this.$success({ content: 'Import đơn hàng thành công' })
          this.closeModal()
        }
      }).catch(err => {
        const msg = this.handleApiError(err)
        this.$notification.error({
          message: '',
          description: msg,
          duration: 5
        })
      }).finally(res => {
        this.loading = false
      })
    }
  }
}
</script>
